import { FlexColMiddle } from '../shared/Flex';
import { Icon } from '../shared/Icon';
import IconArrow from '../../../public/icons/arrow.svg?react';

export function OSToggle({ active, setActive }: { active: boolean; setActive: (active: boolean) => void }) {
	return (
		<FlexColMiddle
			onClick={() => setActive(!active)}
			style={{ height: '100%', alignItems: 'center', cursor: 'pointer' }}
		>
			<Icon
				$colorFill="text_title_main"
				style={{
					height: 16,
					transform: !active ? 'rotate(90deg)' : 'rotate(270deg)',
					transformOrigin: '50% 50%',
				}}
			>
				<IconArrow />
			</Icon>
		</FlexColMiddle>
	);
}
